import { SCANBACK_CHANGE } from 'containers/Dashboard/Home/constants'
import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import { DATE_FILTER_CHANGE } from '../Flow/constants'

import { DATA_REQUEST_ASYNC } from './constants'

export default function () {
  const initialState = {
    data: {},
    loader: false,
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case DATE_FILTER_CHANGE:
        return {
          ...state,
          dateFilter: action.payload.dateFilter,
          loader: true,
        }

      case COMPANY_FILTER_CHANGE:
      case SCANBACK_CHANGE:
      case DATA_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
        }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case DATA_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
        }
      default:
        return state
    }
  }
}
